const DEFAULT_CHANNEL_LOGO_SIZE = 38;

/**
 * Пресеты размеров логотипа
 * @type {number[]}
 */
const CHANNEL_LOGO_SIZES = [
    //16,
    38,
    //70,
    //120,
    //140,
    //160
];

module.exports = {

    /**
     * @param {Number|String} size
     * @returns {Number}
     */
    getChannelLogoSize(size) {
        return CHANNEL_LOGO_SIZES.indexOf(size) > -1 ? size : null;
    },

    getDefaultChannelLogoSize() {
        return this.getChannelLogoSize(DEFAULT_CHANNEL_LOGO_SIZE);
    },

    /**
     * Находим ближайший наибольший размер изображения
     * @param {Object} sizes размеры
     * @param {Number} needleSize нужный размер
     * @returns {Number|Null}
     * @private
     */
    getNearestSize(sizes, needleSize) {
        let nearestSize = needleSize;

        if (!sizes[needleSize]) {
            const sizeKeys = Object.keys(sizes);

            nearestSize = sizeKeys.reduce((prevSize, size) => {
                const sizeIsCloser = Math.abs(size - needleSize) < Math.abs(prevSize - needleSize);
                const sizeIsLarger = Math.abs(size - needleSize) < Math.abs(size - prevSize);

                return sizeIsCloser || sizeIsLarger ? size : prevSize;

            }, sizeKeys.shift());
        }

        return Number(nearestSize) || null;
    },
};
